<script lang="ts">
  import { onMount, tick } from 'svelte'
  import { responseRecovery } from '../lib/response-recovery'

  let recovery = $state(responseRecovery.snapshot())
  let alert = $state<HTMLDivElement>()

  onMount(() => responseRecovery.subscribe((snapshot) => {
    recovery = snapshot
    if (snapshot.banner?.focus) void tick().then(() => alert?.focus())
  }))
</script>

{#if recovery.banner}
  <div
    bind:this={alert}
    data-response-contract-banner
    role="alert"
    tabindex="-1"
    class="mx-auto mt-4 flex max-w-3xl items-start justify-between gap-4 rounded border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900"
  >
    <p>{recovery.banner.message}</p>
    <button
      type="button"
      class="shrink-0 underline"
      onclick={() => responseRecovery.dismissBanner()}
    >
      Dismiss
    </button>
  </div>
{/if}
